import { describe, it, expect } from 'vitest';
import type { CustomerSnapshotAPI } from 'app/react/api/models/customer-snapshot';
import type { OrganizationSnapshotAPI } from 'app/react/api/models/organization-snapshot';
import { buildClientName, buildOrganizationAddress } from './text-builder';

describe('Unit | Utility | mandates | text-builder', () => {
  describe(buildClientName, () => {
    it('returns name when name is provided', () => {
      const clientSnapshot: CustomerSnapshotAPI = {
        id: 'client-1',
        name: 'John Michael Doe',
        first_name: 'John',
        last_name: 'Doe',
        email: 'john@example.com',
        kind: 'individual',
        locale: 'en',
        address: '123 Main St',
        city: 'Paris',
        zip_code: '75001',
        province_code: '',
        country_code: 'FR',
      };

      const result = buildClientName(clientSnapshot);

      expect(result).toBe('John Michael Doe');
    });

    it('builds name from first_name and last_name when name is empty', () => {
      const clientSnapshot: CustomerSnapshotAPI = {
        id: 'client-2',
        name: '',
        first_name: 'Jane',
        last_name: 'Smith',
        email: 'jane@example.com',
        kind: 'individual',
        locale: 'en',
        address: '456 Oak Ave',
        city: 'Lyon',
        zip_code: '69001',
        province_code: 'RA',
        country_code: 'FR',
      };

      const result = buildClientName(clientSnapshot);

      expect(result).toBe('Jane Smith');
    });

    it('handles missing first_name', () => {
      const clientSnapshot: CustomerSnapshotAPI = {
        id: 'client-4',
        name: '',
        first_name: '',
        last_name: 'Johnson',
        email: 'johnson@example.com',
        kind: 'individual',
        locale: 'en',
        address: '321 Pine St',
        city: 'Nice',
        zip_code: '06000',
        province_code: 'PACA',
        country_code: 'FR',
      };

      const result = buildClientName(clientSnapshot);

      expect(result).toBe('Johnson');
    });

    it('handles missing last_name', () => {
      const clientSnapshot: CustomerSnapshotAPI = {
        id: 'client-5',
        name: '',
        first_name: 'Marie',
        last_name: '',
        email: 'marie@example.com',
        kind: 'individual',
        locale: 'fr',
        address: '654 Elm St',
        city: 'Toulouse',
        zip_code: '31000',
        province_code: 'OCC',
        country_code: 'FR',
      };

      const result = buildClientName(clientSnapshot);

      expect(result).toBe('Marie');
    });
  });

  describe(buildOrganizationAddress, () => {
    it('builds address with all fields present', () => {
      const organizationSnapshot: OrganizationSnapshotAPI = {
        id: 'org-1',
        name: 'Test Company',
        logo_url: 'https://example.com/logo.png',
        address_line_1: '123 Business St',
        address_line_2: 'Suite 100',
        city: 'Paris',
        zip_code: '75001',
        country: 'FR',
      };

      const result = buildOrganizationAddress(organizationSnapshot);

      expect(result).toBe('123 Business St Suite 100, 75001 Paris, FR');
    });

    it('builds address without address_line_2', () => {
      const organizationSnapshot: OrganizationSnapshotAPI = {
        id: 'org-2',
        name: 'Simple Company',
        logo_url: 'https://example.com/logo2.png',
        address_line_1: '456 Main Ave',
        address_line_2: '',
        city: 'Lyon',
        zip_code: '69001',
        country: 'FR',
      };

      const result = buildOrganizationAddress(organizationSnapshot);

      expect(result).toBe('456 Main Ave, 69001 Lyon, FR');
    });
  });
});
